import type { SVGProps } from 'react';
const DawnFlagIS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-IS_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-IS_svg__a)">
      <path fill="#0E4CB5" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 9.6h6.286V16h3.143V9.6H22V6.4H9.429V0H6.286v6.4H0z"
        clipRule="evenodd"
      />
      <path
        fill="#EB363A"
        fillRule="evenodd"
        d="M0 8.533h7.333V16h1.048V8.533H22V7.467H8.38V0H7.334v7.467H0z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagIS;
